import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import MenuPlanner from "./MenuPlanner";
import GetAPI from "../../APICalls/GetAPI";
import Select from 'react-select';

const statusFields = {
  Leads: [
    { name: "companyName", type: "text", editable: true, required: true },
    { name: "phoneNumber", type: "text", editable: true, required: true },
    { name: "menuName", type: "dropdown", editable: true, required: true },
    { name: "quantity", type: "text", editable: true, required: true },
    {
      name: "preference",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["Veg", "Non-Veg"],
    },
    {
      name: "cuisine",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["South Indian", "North Indian", "Mixed"],
    },
    { name: "landmark", type: "text", editable: true, required: false },
    { name: "companyLat", type: "number", editable: true, required: true },
    { name: "companyLng", type: "number", editable: true, required: true },
    { name: "startDate", type: "date", editable: true, required: false },
    { name: "pricing", type: "number", editable: true, required: false },
    { name: "currentProblem", type: "text", editable: true, required: false },
    { name: "sampleSchedule", type: "date", editable: true, required: false },
  ],
  Contacted: [
    { name: "companyName", type: "text", editable: true, required: true },
    { name: "phoneNumber", type: "text", editable: true, required: true },
    { name: "menuName", type: "dropdown", editable: true, required: true },
    { name: "quantity", type: "text", editable: true, required: true },
    {
      name: "preference",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["Veg", "Non-Veg"],
    },
    {
      name: "cuisine",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["South Indian", "North Indian", "Mixed"],
    },
    { name: "landmark", type: "text", editable: true, required: false },
    { name: "companyLat", type: "number", editable: true, required: true },
    { name: "companyLng", type: "number", editable: true, required: true },
    { name: "startDate", type: "date", editable: true, required: true },
    { name: "pricing", type: "number", editable: true, required: true },
    { name: "currentProblem", type: "text", editable: true, required: false },
    { name: "sampleSchedule", type: "date", editable: true, required: false },
    { name: "emailID", type: "text", editable: true, required: true },
    { name: "companySize", type: "number", editable: true, required: true },
    {
      name: "conversion",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["Hot", "Warm", "Cold"],
    },
  ],
  Onboarded: [
    { name: "companyName", type: "text", editable: true, required: true },
    { name: "phoneNumber", type: "text", editable: true, required: true },
    { name: "menuName", type: "dropdown", editable: true, required: true },
    { name: "quantity", type: "text", editable: true, required: true },
    {
      name: "preference",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["Veg", "Non-Veg"],
    },
    {
      name: "cuisine",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["South Indian", "North Indian", "Mixed"],
    },
    { name: "emailID", type: "text", editable: true, required: true },
    { name: "startDate", type: "date", editable: true, required: true },
    { name: "chefPrice", type: "number", editable: true, required: true },
    { name: "sellingPrice", type: "number", editable: true, required: true },
    { name: "deliveryCharge", type: "number", editable: true, required: false },
    {
      name: "menuType",
      type: "dropdown",
      editable: true,
      required: false,
      options: ["Breakfast", "Lunch", "Snacks", "Dinner"],
    },
    {
      name: "timeSlot",
      type: "dropdown",
      editable: true,
      required: true,
      options: [],
    },
    { name: "chefID", type: "dropdown", editable: true, required: true },
    { name: "companyLat", type: "number", editable: true, required: true },
    { name: "companyLng", type: "number", editable: true, required: true },
    { name: "companyAddress", type: "text", editable: true, required: true },
  ],
  ChefAssigning: [
    { name: "companyName", type: "text", editable: true, required: true },
    { name: "phoneNumber", type: "text", editable: true, required: true },
    { name: "menuName", type: "dropdown", editable: true, required: true },
    { name: "quantity", type: "text", editable: true, required: true },
    {
      name: "preference",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["Veg", "Non-Veg"],
    },
    {
      name: "cuisine",
      type: "dropdown",
      editable: true,
      required: true,
      options: ["South Indian", "North Indian", "Both"],
    },
    { name: "emailID", type: "text", editable: true, required: true },
    { name: "startDate", type: "date", editable: true, required: true },
    { name: "chefPrice", type: "number", editable: true, required: true },
    { name: "sellingPrice", type: "number", editable: true, required: true },
    { name: "deliveryCharge", type: "number", editable: true, required: false },
    {
      name: "menuType",
      type: "dropdown",
      editable: true,
      required: false,
      options: ["Breakfast", "Lunch", "Snacks", "Dinner"],
    },
    {
      name: "timeSlot",
      type: "dropdown",
      editable: true,
      required: true,
      options: [],
    },
    { name: "chefID", type: "dropdown", editable: true, required: true },
    { name: "companyLat", type: "number", editable: true, required: true },
    { name: "companyLng", type: "number", editable: true, required: true },
    { name: "companyAddress", type: "text", editable: true, required: true },
  ],
  Dropped: [
    { name: "companyName", type: "text", editable: false, required: true },
    { name: "phoneNumber", type: "text", editable: false, required: true },
    { name: "menuName", type: "dropdown", editable: false, required: true },
    { name: "quantity", type: "text", editable: false, required: true },
    {
      name: "preference",
      type: "dropdown",
      editable: false,
      required: true,
      options: ["Veg", "Non-Veg"],
    },
    {
      name: "cuisine",
      type: "dropdown",
      editable: false,
      required: true,
      options: ["South Indian", "North Indian", "Both"],
    },
    { name: "startDate", type: "date", editable: false, required: true },
    { name: "chefPrice", type: "number", editable: false, required: true },
    { name: "sellingPrice", type: "number", editable: false, required: true },
    { name: "deliveryCharge", type: "number", editable: false, required: false },
    {
      name: "menuType",
      type: "dropdown",
      editable: false,
      required: false,
      options: ["Breakfast", "Lunch", "Snacks", "Dinner"],
    },
    {
      name: "timeSlot",
      type: "dropdown",
      editable: false,
      required: true,
      options: [],
    },
    { name: "chefID", type: "dropdown", editable: false, required: true },
    { name: "companyLat", type: "number", editable: false, required: true },
    { name: "companyLng", type: "number", editable: false, required: true },
    { name: "companyAddress", type: "text", editable: false, required: true },
  ],
};

const StatusUpdatePopup = ({
  show,
  confirmStatusUpdate,
  handleDismiss,
  currentStatus,
  chefs,
  selectedRow,
  corporateMenu,
}) => {
  const [formData, setFormData] = useState({
    chefID: "",
    chefData: {
      value: "",
      label: "",
    },
    timeSlot: "07:30 AM - 08:30 AM",
  });
  const [showMenuPlanner, setShowMenuPlanner] = useState(false);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);

  const handleMenuPlannerOpen = () => {
    setShowMenuPlanner(true);
  };

  const handleMenuPlannerClose = () => {
    setShowMenuPlanner(false);
  };

  useEffect(() => {
    if (selectedRow) {
      const initialData = {};
      (statusFields[currentStatus] || []).forEach((field) => {
        if (field.name === "menuName") {
          const selectedMenu = corporateMenu.find(
            (menu) => menu.menuName === selectedRow.menuName
          );
          initialData[field.name] = selectedMenu ? selectedMenu.menuName : ""; // Prepopulate with menu name
        } else if (field.name === "chefID") {
          const selectedChef = chefs.find((chef) => chef.value === selectedRow.chefID);
          initialData[field.name] = selectedRow.chefID;
          initialData.chefData = {
            value: selectedRow.chefID,
            label: selectedChef ? selectedChef.label : "",
          };
        } else if (field.name === "timeSlot") {
          const selectedTimeSlot = selectedRow.timeSlot;
          initialData[field.name] = selectedTimeSlot;
        } else {
          initialData[field.name] = selectedRow[field.name] || "";
        }
      });
      setFormData(initialData);
    }
  }, [selectedRow, currentStatus, corporateMenu]);

  useEffect(() => {
    const getMenuTypeTimings = async () => {
      try {
        let environment = process.env.REACT_APP_NODE_ENV;
        let utilityApi =
          environment === "PRODUCTION"
            ? process.env.REACT_APP_PROD_UTILITY
            : process.env.REACT_APP_DEV_UTILITY;

        let completeUtilityURL = `${utilityApi}?type=DELIVERY_TIMINGS&isTomorrow=true`;
        const res = await GetAPI(completeUtilityURL);

        if (res.data.statusCode === 200) {
          const timingsEntry = res.data.body[0]?.value[formData.menuType];

          if (timingsEntry) {
            const availableSlots = timingsEntry.map((slot) => ({
              value: slot.slot,
              label: slot.slot,
            }));

            setAvailableTimeSlots(availableSlots);
            setFormData((prevState) => ({
              ...prevState,
              timeSlot: availableSlots[0].value, // Set the first available time slot as the default
            }));
          }
        } else {
          console.error("Error occurred. Error =", res);
        }
      } catch (e) {
        console.error("Error occurred. Error =", e);
      }
    };

    if (formData.menuType && formData.menuType !== "") {
      getMenuTypeTimings();
    }
  }, [formData.menuType]);

  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (nextStatus) => {
    const { status, prevStatus, timeSlotOptions, chefData, ...rest } = formData;
    const record = {
      ...selectedRow,
      ...rest,
      status: nextStatus,
      prevStatus: currentStatus,
    };

    if (nextStatus === "Onboarded" || nextStatus === "ChefAssigning") {
      confirmStatusUpdate(record, "NEW");
    } else {
      confirmStatusUpdate(record);
    }
  };

  const handleUpdate = () => {
    const { status, prevStatus, timeSlotOptions, chefData, ...rest } = formData;

    const record = {
      ...selectedRow,
      ...rest,
      status: currentStatus,
      prevStatus: currentStatus,
    };

    confirmStatusUpdate(record);
  };

  const handleNew = () => {
    const { status, prevStatus, timeSlotOptions, chefData, ...rest } = formData;

    const record = {
      ...selectedRow,
      ...rest,
      status: currentStatus,
      prevStatus: currentStatus,
    };
    confirmStatusUpdate(record, "NEW");
  };

  const handleClose = () => {
    handleDismiss();
  };

  const fieldsToRender = statusFields[currentStatus] || [];

  const getNextStatusOptions = () => {
    switch (currentStatus) {
      case "Leads":
        return ["Contacted", "Dropped"];
      case "Contacted":
        return ["Onboarded", "Dropped"];
      case "Onboarded":
        return ["ChefAssigning", "Dropped"];
      case "ChefAssigning":
        return ["Dropped"];
      default:
        return [];
    }
  };

  const handleMenuChange = (event) => {
    const selectedMenuName = event.target.value;
    const selectedMenuObject = corporateMenu.find(
      (menu) => menu.menuName === selectedMenuName
    );

    setFormData({
      ...formData,
      menuName: selectedMenuObject ? selectedMenuObject.menuName : selectedRow.menuName,
      menuDesc: selectedMenuObject ? selectedMenuObject.menuDesc : selectedRow.menuDesc,
      menuID: selectedMenuObject ? selectedMenuObject.menuID : selectedRow.menuID,
      imageUrl: selectedMenuObject ? selectedMenuObject.imageUrl : selectedRow.imageUrl,
    });
  };

  const handleChange = (field, value) => {
  if (field === "chefID") {
    const selectedChef = chefs.find((chef) => chef.value === value);
    setFormData({ ...formData, chefID: value, chefData: { value: value, label: selectedChef.label } });
  } else {
    setFormData({ ...formData, [field]: value });
  }
};

  const nextStatusOptions = getNextStatusOptions();

  return (
    <>
      <Modal size="lg" show={show} backdrop="static">
        <Modal.Header>
          <Modal.Title>Status Update</Modal.Title>
          <span onClick={handleClose}>&#10006;</span>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div>
              {fieldsToRender.length > 0 ? (
                <div className="row">
                  {fieldsToRender.map((field) => (
                    <div key={field.name} className="col-md-4">
                      <div className="form-group">
                        <label>
                          {field.name}{" "}
                          {field.required && (
                            <span style={{ color: "red" }}>*</span>
                          )}
                        </label>
                        {field.name === "menuName" &&
                          field.type === "dropdown" ? (
                          <select
                            className="form-control"
                            value={formData.menuName || ""}
                            onChange={handleMenuChange}
                          >
                            {corporateMenu.map((menu) => (
                              <option key={menu.menuID} value={menu.menuName}>
                                {menu.menuName}
                              </option>
                            ))}
                          </select>
                        ) : field.type === "dropdown" && field.name === "chefID" ? (
                          <Select
                            value={formData.chefID ? { value: formData.chefID, label: formData.chefData.label } : null}
                            onChange={(e) => {
                              handleChange("chefID", e.value);
                            }}
                            options={chefs}
                            isSearchable={true}
                            placeholder="Select Chef"
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? 'blue' : 'gray',
                              }),
                            }}
                          />
                        ) : field.name === "timeSlot" &&
                          field.type === "dropdown" ? (
                            <Select
                            value={availableTimeSlots.find((slot) => slot.value === formData.timeSlot)}
                            onChange={(e) => handleChange("timeSlot", e.value)}
                            options={availableTimeSlots}
                            isSearchable={true}
                            placeholder="Select Time Slot"
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? 'blue' : 'gray',
                              }),
                            }}
                          />
                          ) : field.type === "dropdown" ? (
                            <select
                              className="form-control"
                              value={formData[field.name] || ""}
                              onChange={(e) =>
                                handleInputChange(field.name, e.target.value)
                              }
                            >
                              {field.options?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input
                              type={field.type}
                              className="form-control"
                              value={formData[field.name] || ""}
                              onChange={(e) => handleInputChange(field.name, e.target.value)}
                              readOnly={!field.editable}
                              maxLength={field.name === "phoneNumber" ? 10 : undefined}
                            />
                          )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          {currentStatus == "ChefAssigning" ? (
            <button onClick={handleNew} className="btn btn-primary">
              Create another Record
            </button>
          ) : null}
          {currentStatus !== "Dropped" ? (
            <button onClick={handleUpdate} className="btn btn-primary">
              Update Status
            </button>
          ) : null}
          {nextStatusOptions.map((status) => (
            <button
              key={status}
              className="btn btn-primary"
              onClick={() => handleSubmit(status)}
            >
              Move to {status}
            </button>
          ))}
          <button className="btn btn-secondary " onClick={handleClose}>
            Cancel
          </button>
          {currentStatus === "ChefAssigning" ? (
            <button className="btn btn-primary" onClick={handleMenuPlannerOpen}>
              Open Menu Planner
            </button>
          ) : null}
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={showMenuPlanner} backdrop="static">
        <Modal.Header>
          <Modal.Title>Menu Planner</Modal.Title>
          <span onClick={handleMenuPlannerClose}>&#10006;</span>
        </Modal.Header>
        <Modal.Body>
          <MenuPlanner uuID={selectedRow.uuID} />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={handleMenuPlannerClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StatusUpdatePopup;